import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  public go(href: string): void {
    window.location.href = href;
  }
}
